<template lang="pug">
  div
    order-step(:current-step="5" failure)
    h2 Fehler
    div.px-4.py-4.text-danger.min-height
      div Ihre Bestellung konnte nicht abgeschickt werden.
      div Gehen Sie bitte zurück und versuchen Sie es erneut.
    div.card-footer.text-right
      button.mr-2.btn.btn-primary.btn-lg(
        type="button"
        @click="goBack"
        )
        | Zurück
      button.btn(
        type="button"
        @click="showMenu"
        )
        | Abbrechen
</template>

<script>
import { mapActions } from 'vuex'
import OrderStep from '@/components/orderForm/orderStep'

export default {
  name: 'OrderFailure',
  components: {
    OrderStep
  },
  methods: {
    ...mapActions('ui', [
      'goBack',
      'showMenu'
    ])
  }
}
</script>
